/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */
import { FooterLangSelector, OpenInNewTab, OpenInSameTab, UHFFooterLinksClassName } from "../constants";

import React from "react";

interface FooterProps {
  body: string;
}
export const UHFBottomFooter: React.FC<FooterProps> = ({ body }) => {
  let footerHTML = { __html: body };
  //To Hide the Locale Picker
  React.useEffect(() => {
    footerHTML = { __html: body };
    //eslint-disable-next-line
    const localePicker: any = document.getElementById(FooterLangSelector);
    if (localePicker) {
      localePicker.style.display = "none";
    }
    const footerAnchorElements = document.getElementsByClassName(
      UHFFooterLinksClassName
    );
    for (let i = 0; i < footerAnchorElements.length; i++) {
      footerAnchorElements[i].addEventListener("click", universalFooterEvent);
    }
  }, [body]);

  //eslint-disable-next-line
  function universalFooterEvent(sender: any) {
    sender.preventDefault();
    const anchorLink = sender.target.getAttribute("href");
    const target = sender.target.innerText === "Careers" ? OpenInSameTab : OpenInNewTab;
    window.open(anchorLink, target);
  }

  return <div role="contentinfo" dangerouslySetInnerHTML={footerHTML}></div>;
};
